import {
  GET_INVOICE_LIST,
  GET_INVOICE_LIST_SUCCESS,
  GET_INVOICE_LIST_ERROR,
  GET_INVOICE_STATUS_LIST,
  GET_INVOICE_STATUS_LIST_SUCCESS,
  GET_INVOICE_STATUS_LIST_ERROR,
  GET_INVOICE_SINGLE_PDF,
  GET_INVOICE_SINGLE_PDF_SUCCESS,
  GET_INVOICE_SINGLE_PDF_ERROR,
  GET_SINGLE_INVOICE_DATA,
  GET_SINGLE_INVOICE_DATA_SUCCESS,
  GET_SINGLE_INVOICE_DATA_ERROR,
  CREATE_SINGLE_INVOICE_DATA,
  CREATE_SINGLE_INVOICE_DATA_SUCCESS,
  CREATE_SINGLE_INVOICE_DATA_ERROR,
  UPDATE_SINGLE_INVOICE_DATA,
  UPDATE_SINGLE_INVOICE_DATA_SUCCESS,
  UPDATE_SINGLE_INVOICE_DATA_ERROR,
  SEARCH_SINGLE_CUSTOMER_INVOICE_LIST,
  SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_ERROR,
  SEARCH_JOB_INVOICE_LIST,
  SEARCH_JOB_INVOICE_LIST_SUCCESS,
  SEARCH_JOB_INVOICE_LIST_ERROR,
  RESEND_INVOICE_EMAIL,
  RESEND_INVOICE_EMAIL_SUCCESS,
  RESEND_INVOICE_EMAIL_ERROR,
  SEND_INVOICE_EMAIL,
  SEND_INVOICE_EMAIL_SUCCESS,
  SEND_INVOICE_EMAIL_ERROR,
  VOID_INVOICE,
  VOID_INVOICE_SUCCESS,
  VOID_INVOICE_ERROR,
  REINVOICE,
  REINVOICE_SUCCESS,
  REINVOICE_ERROR,
  ADD_NEW_INVOICE_STATUS,
  ADD_NEW_INVOICE_STATUS_SUCCESS,
  ADD_NEW_INVOICE_STATUS_ERROR,
  DELETE_INVOICE_STATUS,
  DELETE_INVOICE_STATUS_SUCCESS,
  DELETE_INVOICE_STATUS_ERROR,
  UPDATE_INVOICE_STATUS,
  UPDATE_INVOICE_STATUS_SUCCESS,
  UPDATE_INVOICE_STATUS_ERROR,
  GET_INVOICE_PAYMENT_METHOD_LIST,
  GET_INVOICE_PAYMENT_METHOD_LIST_SUCCESS,
  GET_INVOICE_PAYMENT_METHOD_LIST_ERROR,
  ADD_NEW_INVOICE_PAYMENT_METHOD,
  ADD_NEW_INVOICE_PAYMENT_METHOD_SUCCESS,
  ADD_NEW_INVOICE_PAYMENT_METHOD_ERROR,
  DELETE_INVOICE_PAYMENT_METHOD,
  DELETE_INVOICE_PAYMENT_METHOD_SUCCESS,
  DELETE_INVOICE_PAYMENT_METHOD_ERROR,
  UPDATE_INVOICE_PAYMENT_METHOD,
  UPDATE_INVOICE_PAYMENT_METHOD_SUCCESS,
  UPDATE_INVOICE_PAYMENT_METHOD_ERROR,
  GET_MASTER_INVOICE_LIST,
  GET_MASTER_INVOICE_LIST_SUCCESS,
  GET_MASTER_INVOICE_LIST_ERROR,
  GET_MASTER_INVOICE_SINGLE_DATA,
  GET_MASTER_INVOICE_SINGLE_DATA_SUCCESS,
  GET_MASTER_INVOICE_SINGLE_DATA_ERROR,
  GET_CRMIT_INVOICE_PDF_SINGLE,
  GET_CRMIT_INVOICE_PDF_SINGLE_SUCCESS,
  GET_CRMIT_INVOICE_PDF_SINGLE_ERROR,
  GET_INVOICE_ITEM_LIST,
  GET_INVOICE_ITEM_LIST_SUCCESS,
  GET_INVOICE_ITEM_LIST_ERROR,
  GET_MASTER_INVOICE_LIST_CUSTOMER,
  GET_MASTER_INVOICE_LIST_CUSTOMER_SUCCESS,
  GET_MASTER_INVOICE_LIST_CUSTOMER_ERROR,
  SEARCH_INVOICE_ACTIVITY_LOG,
  SEARCH_INVOICE_ACTIVITY_LOG_SUCCESS,
  SEARCH_INVOICE_ACTIVITY_LOG_ERROR,
  SEARCH_INVOICE_ITEMS_LIST,
  SEARCH_INVOICE_ITEMS_LIST_SUCCESS,
  SEARCH_INVOICE_ITEMS_LIST_ERROR,
  GET_JOB_INVOICE_ITEM_TEMPLATE_LIST,
  GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_SUCCESS,
  GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_ERROR,
  GET_JOB_INVOICE_ITEM_TEMPLATE_DATA,
  GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_SUCCESS,
  GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_ERROR,
  SEARCH_JOB_INVOICE_ITEM_TEMPLATE,
  SEARCH_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  SEARCH_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  CREATE_JOB_INVOICE_ITEM_TEMPLATE,
  CREATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  CREATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  UPDATE_JOB_INVOICE_ITEM_TEMPLATE,
  UPDATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  UPDATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  DELETE_JOB_INVOICE_ITEM_TEMPLATE,
  DELETE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  DELETE_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
} from "./actionType";

// get Invoice List
export const getInvoiceList = () => ({
  type: GET_INVOICE_LIST,
});

// get Invoice List Success
export const getInvoiceListSuccess = (data) => ({
  type: GET_INVOICE_LIST_SUCCESS,
  payload: data,
});

// get Invoice List Error
export const getInvoiceListError = (error) => ({
  type: GET_INVOICE_LIST_ERROR,
  payload: error,
});

// get Invoice Status List

export const getInvoiceStatusList = () => ({
  type: GET_INVOICE_STATUS_LIST,
});

// get Invoice Status List Success
export const getInvoiceStatusListSuccess = (data) => ({
  type: GET_INVOICE_STATUS_LIST_SUCCESS,
  payload: data,
});

// get Invoice Status List Error
export const getInvoiceStatusListError = (error) => ({
  type: GET_INVOICE_STATUS_LIST_ERROR,
  payload: error,
});

// get Invoice Single PDF

export const getInvoiceSinglePDF = (id) => ({
  type: GET_INVOICE_SINGLE_PDF,
  payload: id,
});

// get Invoice Single PDF Success
export const getInvoiceSinglePDFSuccess = (data) => ({
  type: GET_INVOICE_SINGLE_PDF_SUCCESS,
  payload: data,
});

// get Invoice Single PDF Error
export const getInvoiceSinglePDFError = (error) => ({
  type: GET_INVOICE_SINGLE_PDF_ERROR,
  payload: error,
});

// Get Single Invoice Data

export const getSingleInvoiceData = (id) => ({
  type: GET_SINGLE_INVOICE_DATA,
  payload: id,
});

// Get Single Invoice Data Success

export const getSingleInvoiceDataSuccess = (data) => ({
  type: GET_SINGLE_INVOICE_DATA_SUCCESS,
  payload: data,
});

// Get Single Invoice Data Error

export const getSingleInvoiceDataError = (error) => ({
  type: GET_SINGLE_INVOICE_DATA_ERROR,
  payload: error,
});

// Create Single Invoice Data

export const createSingleInvoiceData = (data) => ({
  type: CREATE_SINGLE_INVOICE_DATA,
  payload: data,
});

// Create Single Invoice Data Success

export const createSingleInvoiceDataSuccess = (data) => ({
  type: CREATE_SINGLE_INVOICE_DATA_SUCCESS,
  payload: data,
});

// Create Single Invoice Data Error

export const createSingleInvoiceDataError = (error) => ({
  type: CREATE_SINGLE_INVOICE_DATA_ERROR,
  payload: error,
});

// Update Single Invoice Data

export const updateSingleInvoiceData = (data) => ({
  type: UPDATE_SINGLE_INVOICE_DATA,
  payload: data,
});

// Update Single Invoice Data Success

export const updateSingleInvoiceDataSuccess = (data) => ({
  type: UPDATE_SINGLE_INVOICE_DATA_SUCCESS,
  payload: data,
});

// Update Single Invoice Data Error

export const updateSingleInvoiceDataError = (error) => ({
  type: UPDATE_SINGLE_INVOICE_DATA_ERROR,
  payload: error,
});

// Search Single Customer Invoice List

export const searchSingleCustomerInvoiceList = (payload) => ({
  type: SEARCH_SINGLE_CUSTOMER_INVOICE_LIST,
  payload: payload,
});

// Search Single Customer Invoice List Success

export const searchSingleCustomerInvoiceListSuccess = (payload) => ({
  type: SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_SUCCESS,
  payload: payload,
});

// Search Single Customer Invoice List Error

export const searchSingleCustomerInvoiceListError = (error) => ({
  type: SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_ERROR,
  payload: error,
});

// Search Job Invoice List (single-job Invoices tab)

export const searchJobInvoiceList = (payload) => ({
  type: SEARCH_JOB_INVOICE_LIST,
  payload: payload,
});

export const searchJobInvoiceListSuccess = (payload) => ({
  type: SEARCH_JOB_INVOICE_LIST_SUCCESS,
  payload: payload,
});

export const searchJobInvoiceListError = (error) => ({
  type: SEARCH_JOB_INVOICE_LIST_ERROR,
  payload: error,
});

// Resend Invoice Email

export const resendInvoiceEmail = (id) => ({
  type: RESEND_INVOICE_EMAIL,
  payload: id,
});

// Resend Invoice Email Success

export const resendInvoiceEmailSuccess = (id) => ({
  type: RESEND_INVOICE_EMAIL_SUCCESS,
  payload: id,
});

// Resend Invoice Email Error

export const resendInvoiceEmailError = (error) => ({
  type: RESEND_INVOICE_EMAIL_ERROR,
  payload: error,
});

// Send Invoice Email

export const sendInvoiceEmail = (id) => ({
  type: SEND_INVOICE_EMAIL,
  payload: id,
});

// Send Invoice Email Success

export const sendInvoiceEmailSuccess = (data) => ({
  type: SEND_INVOICE_EMAIL_SUCCESS,
  payload: data,
});

// Send Invoice Email Error

export const sendInvoiceEmailError = (error) => ({
  type: SEND_INVOICE_EMAIL_ERROR,
  payload: error,
});

// Void Invoice

export const voidInvoice = (id) => ({
  type: VOID_INVOICE,
  payload: id,
});

// Void Invoice Success

export const voidInvoiceSuccess = (response) => ({
  type: VOID_INVOICE_SUCCESS,
  payload: response,
});

// Void Invoice Error

export const voidInvoiceError = (error) => ({
  type: VOID_INVOICE_ERROR,
  payload: error,
});

// Re-invoice

export const reinvoice = (id) => ({
  type: REINVOICE,
  payload: id,
});

// Re-invoice Success

export const reinvoiceSuccess = (response) => ({
  type: REINVOICE_SUCCESS,
  payload: response,
});

// Re-invoice Error

export const reinvoiceError = (error) => ({
  type: REINVOICE_ERROR,
  payload: error,
});

// Add New Invoice Status
export const addNewInvoiceStatus = (data) => ({
  type: ADD_NEW_INVOICE_STATUS,
  payload: data,
});

// Add New Invoice Status Success
export const addNewInvoiceStatusSuccess = (data) => ({
  type: ADD_NEW_INVOICE_STATUS_SUCCESS,
  payload: data,
});

// Add New Invoice Status Error
export const addNewInvoiceStatusError = (error) => ({
  type: ADD_NEW_INVOICE_STATUS_ERROR,
  payload: error,
});

// Delete Invoice Status
export const deleteInvoiceStatus = (id) => ({
  type: DELETE_INVOICE_STATUS,
  payload: id,
});

// Delete Invoice Status Success
export const deleteInvoiceStatusSuccess = (id) => ({
  type: DELETE_INVOICE_STATUS_SUCCESS,
  payload: id,
});

// Delete Invoice Status Error
export const deleteInvoiceStatusError = (error) => ({
  type: DELETE_INVOICE_STATUS_ERROR,
  payload: error,
});

// Update Invoice Status
export const updateInvoiceStatus = (data) => ({
  type: UPDATE_INVOICE_STATUS,
  payload: data,
});

// Update Invoice Status Success
export const updateInvoiceStatusSuccess = (data) => ({
  type: UPDATE_INVOICE_STATUS_SUCCESS,
  payload: data,
});

// Update Invoice Status Error
export const updateInvoiceStatusError = (error) => ({
  type: UPDATE_INVOICE_STATUS_ERROR,
  payload: error,
});

// Get Invoice Payment Method List
export const getInvoicePaymentMethodList = () => ({
  type: GET_INVOICE_PAYMENT_METHOD_LIST,
});

// Get Invoice Payment Method List Success
export const getInvoicePaymentMethodListSuccess = (data) => ({
  type: GET_INVOICE_PAYMENT_METHOD_LIST_SUCCESS,
  payload: data,
});

// Get Invoice Payment Method List Error
export const getInvoicePaymentMethodListError = (error) => ({
  type: GET_INVOICE_PAYMENT_METHOD_LIST_ERROR,
  payload: error,
});

// Add New Invoice Payment Method
export const addNewInvoicePaymentMethod = (data) => ({
  type: ADD_NEW_INVOICE_PAYMENT_METHOD,
  payload: data,
});

// Add New Invoice Payment Method Success
export const addNewInvoicePaymentMethodSuccess = (data) => ({
  type: ADD_NEW_INVOICE_PAYMENT_METHOD_SUCCESS,
  payload: data,
});

// Add New Invoice Payment Method Error
export const addNewInvoicePaymentMethodError = (error) => ({
  type: ADD_NEW_INVOICE_PAYMENT_METHOD_ERROR,
  payload: error,
});

// Delete Invoice Payment Method
export const deleteInvoicePaymentMethod = (id) => ({
  type: DELETE_INVOICE_PAYMENT_METHOD,
  payload: id,
});

// Delete Invoice Payment Method Success
export const deleteInvoicePaymentMethodSuccess = (id) => ({
  type: DELETE_INVOICE_PAYMENT_METHOD_SUCCESS,
  payload: id,
});

// Delete Invoice Payment Method Error
export const deleteInvoicePaymentMethodError = (error) => ({
  type: DELETE_INVOICE_PAYMENT_METHOD_ERROR,
  payload: error,
});

// Update Invoice Payment Method
export const updateInvoicePaymentMethod = (data) => ({
  type: UPDATE_INVOICE_PAYMENT_METHOD,
  payload: data,
});

// Update Invoice Payment Method Success
export const updateInvoicePaymentMethodSuccess = (data) => ({
  type: UPDATE_INVOICE_PAYMENT_METHOD_SUCCESS,
  payload: data,
});

// Update Invoice Payment Method Error
export const updateInvoicePaymentMethodError = (error) => ({
  type: UPDATE_INVOICE_PAYMENT_METHOD_ERROR,
  payload: error,
});

// Master Invoice List
export const getMasterInvoiceList = () => ({
  type: GET_MASTER_INVOICE_LIST,
});

// Master Invoice List Success
export const getMasterInvoiceListSuccess = (data) => ({
  type: GET_MASTER_INVOICE_LIST_SUCCESS,
  payload: data,
});

// Master Invoice List Error
export const getMasterInvoiceListError = (error) => ({
  type: GET_MASTER_INVOICE_LIST_ERROR,
  payload: error,
});

// Get Master Invoice Single Data

export const getMasterInvoiceSingleData = (id) => ({
  type: GET_MASTER_INVOICE_SINGLE_DATA,
  payload: id,
});

// Get Master Invoice Single Data Success

export const getMasterInvoiceSingleDataSuccess = (data) => ({
  type: GET_MASTER_INVOICE_SINGLE_DATA_SUCCESS,
  payload: data,
});

// Get Master Invoice Single Data Error

export const getMasterInvoiceSingleDataError = (error) => ({
  type: GET_MASTER_INVOICE_SINGLE_DATA_ERROR,
  payload: error,
});

// Get Crm It Invoice Single Data

export const getCrmItInvoiceSingleData = (id) => ({
  type: GET_CRMIT_INVOICE_PDF_SINGLE,
  payload: id,
});

// Get Crm It Invoice Single Data Success

export const getCrmItInvoiceSingleDataSuccess = (data) => ({
  type: GET_CRMIT_INVOICE_PDF_SINGLE_SUCCESS,
  payload: data,
});

// Get Crm It Invoice Single Data Error

export const getCrmItInvoiceSingleDataError = (error) => ({
  type: GET_CRMIT_INVOICE_PDF_SINGLE_ERROR,
  payload: error,
});

// Get Invoice Item List
export const getInvoiceItemList = () => ({
  type: GET_INVOICE_ITEM_LIST,
});

// Get Invoice Item List Success
export const getInvoiceItemListSuccess = (data) => ({
  type: GET_INVOICE_ITEM_LIST_SUCCESS,
  payload: data,
});

// Get Invoice Item List Error
export const getInvoiceItemListError = (error) => ({
  type: GET_INVOICE_ITEM_LIST_ERROR,
  payload: error,
});

// Get Master Invoice List Customer
export const getMasterInvoiceListCustomer = () => ({
  type: GET_MASTER_INVOICE_LIST_CUSTOMER,
});

// Get Master Invoice List Customer Success
export const getMasterInvoiceListCustomerSuccess = (data) => ({
  type: GET_MASTER_INVOICE_LIST_CUSTOMER_SUCCESS,
  payload: data,
});

// Get Master Invoice List Customer Error
export const getMasterInvoiceListCustomerError = (error) => ({
  type: GET_MASTER_INVOICE_LIST_CUSTOMER_ERROR,
  payload: error,
});

// Search Invoice Activity Log
export const searchInvoiceActivityLog = (id) => ({
  type: SEARCH_INVOICE_ACTIVITY_LOG,
  payload: id,
});

// Search Invoice Activity Log Success
export const searchInvoiceActivityLogSuccess = (data) => ({
  type: SEARCH_INVOICE_ACTIVITY_LOG_SUCCESS,
  payload: data,
});

// Search Invoice Activity Log Error
export const searchInvoiceActivityLogError = (error) => ({
  type: SEARCH_INVOICE_ACTIVITY_LOG_ERROR,
  payload: error,
});

// Search Invoice Items List
export const searchInvoiceItemsList = (id) => ({
  type: SEARCH_INVOICE_ITEMS_LIST,
  payload: id,
});

// Search Invoice Items List Success
export const searchInvoiceItemsListSuccess = (data) => ({
  type: SEARCH_INVOICE_ITEMS_LIST_SUCCESS,
  payload: data,
});

// Search Invoice Items List Error
export const searchInvoiceItemsListError = (error) => ({
  type: SEARCH_INVOICE_ITEMS_LIST_ERROR,
  payload: error,
});

// Get Job Invoice Item Template List
export const getJobInvoiceItemTemplateList = () => ({
  type: GET_JOB_INVOICE_ITEM_TEMPLATE_LIST,
});

// Get Job Invoice Item Template List Success
export const getJobInvoiceItemTemplateListSuccess = (data) => ({
  type: GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_SUCCESS,
  payload: data,
});

// Get Job Invoice Item Template List Error
export const getJobInvoiceItemTemplateListError = (error) => ({
  type: GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_ERROR,
  payload: error,
});

// Get Job Invoice Item Template Data
export const getJobInvoiceItemTemplateData = (id) => ({
  type: GET_JOB_INVOICE_ITEM_TEMPLATE_DATA,
  payload: id,
});

// Get Job Invoice Item Template Data Success
export const getJobInvoiceItemTemplateDataSuccess = (data) => ({
  type: GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_SUCCESS,
  payload: data,
});

// Get Job Invoice Item Template Data Error
export const getJobInvoiceItemTemplateDataError = (error) => ({
  type: GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_ERROR,
  payload: error,
});

// Search Job Invoice Item Template
export const searchJobInvoiceItemTemplate = (id) => ({
  type: SEARCH_JOB_INVOICE_ITEM_TEMPLATE,
  payload: id,
});

// Search Job Invoice Item Template Success
export const searchJobInvoiceItemTemplateSuccess = (data) => ({
  type: SEARCH_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  payload: data,
});

// Search Job Invoice Item Template Error
export const searchJobInvoiceItemTemplateError = (error) => ({
  type: SEARCH_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  payload: error,
});

// Create Job Invoice Item Template
export const createJobInvoiceItemTemplate = (data) => ({
  type: CREATE_JOB_INVOICE_ITEM_TEMPLATE,
  payload: data,
});

// Create Job Invoice Item Template Success
export const createJobInvoiceItemTemplateSuccess = (data) => ({
  type: CREATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  payload: data,
});

// Create Job Invoice Item Template Error
export const createJobInvoiceItemTemplateError = (error) => ({
  type: CREATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  payload: error,
});

// Update Job Invoice Item Template
export const updateJobInvoiceItemTemplate = (data) => ({
  type: UPDATE_JOB_INVOICE_ITEM_TEMPLATE,
  payload: data,
});

// Update Job Invoice Item Template Success
export const updateJobInvoiceItemTemplateSuccess = (data) => ({
  type: UPDATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  payload: data,
});

// Update Job Invoice Item Template Error
export const updateJobInvoiceItemTemplateError = (error) => ({
  type: UPDATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  payload: error,
});

// Delete Job Invoice Item Template
export const deleteJobInvoiceItemTemplate = (id) => ({
  type: DELETE_JOB_INVOICE_ITEM_TEMPLATE,
  payload: id,
});

// Delete Job Invoice Item Template Success
export const deleteJobInvoiceItemTemplateSuccess = (id) => ({
  type: DELETE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS,
  payload: id,
});

// Delete Job Invoice Item Template Error
export const deleteJobInvoiceItemTemplateError = (error) => ({
  type: DELETE_JOB_INVOICE_ITEM_TEMPLATE_ERROR,
  payload: error,
});
